import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';
import { ReactComponent as RACLogo } from '../images/logo color.svg';
import { useTenantTheme } from '../tenant/TenantThemeProvider';

// Componente de animación de carga con branding RAC
const LoadingAnimation = ({ message = "Procesando Imágenes", subMessage = "Analizando fotos exteriores..." }) => {
  const { brandColors } = useTenantTheme();
  const pulse = keyframes`
    0% {
      transform: scale(0.92);
      filter: drop-shadow(0 0 5px ${brandColors.primary}55);
    }

    50% {
      transform: scale(1);
      filter: drop-shadow(0 0 15px ${brandColors.secondary}88);
    }

    100% {
      transform: scale(0.92);
      filter: drop-shadow(0 0 5px ${brandColors.primary}55);
    }
  `;

  return (
    // Contenedor principal para centrar el contenido
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      sx={{
        background: `linear-gradient(45deg, ${brandColors.primary} 0%, ${brandColors.primary} 40%, ${brandColors.secondary} 100%)`,
        color: brandColors.onPrimary
      }}
    >
      {/* Contenedor para el logo con animación de pulso */}
      <Box
        sx={{
          width: '100px',
          height: '100px',
          animation: `${pulse} 2.5s infinite ease-in-out`,
          marginBottom: 3
        }}
      >
        <RACLogo width="100%" height="100%" />
      </Box>
      
      {/* Texto principal */}
      <Typography 
        variant="h4" 
        component="h1"
        gutterBottom 
        sx={{
          fontWeight: 600,
          color: brandColors.onPrimary,
          textShadow: "0 1px 2px rgba(0,0,0,0.1)"
        }}>
        {message}
      </Typography>
      
      {/* Subtexto */}
      <Typography 
        variant="body1"
        sx={{ 
          marginBottom: 4,
          opacity: 0.8
        }}>
        {subMessage}
      </Typography>
      
      {/* Indicador de progreso */}
      <Box sx={{ width: '60%', maxWidth: 400, position: 'relative', marginTop: 2 }}>
        <Box
          sx={{
            height: 10,
            borderRadius: 5,
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: '40%',
              borderRadius: 5,
              backgroundColor: brandColors.onPrimary,
              animation: `progress 1.5s ease-in-out infinite`,
              '@keyframes progress': {
                '0%': { width: '10%', left: '-10%' },
                '100%': { width: '40%', left: '100%' },
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingAnimation;
